import { TemplateData, TemplateParams } from '.';

const courseAccessRequestAccept = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'courses',
  email: {
    buttonEnabled: true,
    buttonLink: '{{courseUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.courseAccessRequestAccept}
      </p>
      <p>
        {{optionalMessage}}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.courseAccessToCourse}`
  },
  placeholders: {
    courseTitle: {
      label: messages.coursesCourseTitle,
      example: 'Test course'
    },
    courseUrl: {
      label: messages.commonCourseLink,
      example: `${serverConfig.adminUrl}/courses/test-course`
    },
    optionalMessage: {
      label: messages.courseAccessRequestAdminMessage,
      example: 'Welcome to the course.'
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeCourseAccessRequestAccept
});

export default courseAccessRequestAccept;
